<script>
  import { PrismEditor } from 'vue-prism-editor';
  import 'vue-prism-editor/dist/prismeditor.min.css';

  import { highlight, highlightAll, languages } from 'prismjs/components/prism-core';
  import 'prismjs/components/prism-clike';
  import 'prismjs/components/prism-javascript';
  import 'prismjs/themes/prism-tomorrow.css';

  export default {
    props: ['value'],
    components: {
      PrismEditor,
    },
    data() {
      return {
        code: '',
      }
    },
    created() {
      this.code = this.value;
    },
    methods: {
      highlighter(code) {
        return highlight(code, languages.js);
      },
      updateCode(content) {
        this.$emit("input", content);
      }
    },
  };
</script>

<template>
  <prism-editor class="prism-editor" v-model="code" :tab-size="4" :highlight="highlighter" line-numbers @input="updateCode"></prism-editor>
</template>
